import { CopyOutlined } from "@ant-design/icons";
import { Card, Descriptions, Tag, Button, Tooltip } from "antd";
import { useState } from "react";

import { copyTextToClipboard } from "../../../utils/clipboardHelper";

const { Item } = Descriptions;

const BlogTreeNodeDetails = ({ node }) => {
  const {
    activeUniqueUrlIdentifier,
    title,
    slug,
    displayOrderUnderParent,
    isFolder,
    isExpandedByDefault
  } = node;
  const [isPreviewLinkCopied, setIsPreviewLinkCopied] = useState(false);

  const previewUrl = activeUniqueUrlIdentifier
    ? `https://www.tle-eliminators.com/cp-digest${activeUniqueUrlIdentifier}?preview=true`
    : "";

  const handleCopyUrl = async () => {
    if (!previewUrl) {
      return;
    }
    const hasCopied = await copyTextToClipboard(previewUrl);
    if (!hasCopied) {
      return;
    }
    setIsPreviewLinkCopied(true);
    setTimeout(() => setIsPreviewLinkCopied(false), 1200);
  };

  return (
    <Card title={title}>
      <Descriptions
        bordered
        column={1}
        styles={{
          // Pinned label column, so switching nodes cannot re-lay-out the whole table
          label: { width: 180, whiteSpace: "nowrap" },
          content: { wordBreak: "break-word" }
        }}
      >
        <Item label="Slug">{slug}</Item>
        <Item label="Display Order">{displayOrderUnderParent}</Item>
        <Item label="Type">
          {isFolder ? <Tag color="blue">Folder</Tag> : <Tag color="green">Blog</Tag>}
        </Item>
        {isFolder && (
          <Item label="Expanded By Default">
            <Tag color={isExpandedByDefault === false ? "default" : "processing"}>
              {isExpandedByDefault === false ? "No" : "Yes"}
            </Tag>
          </Item>
        )}
        <Item label="Active URL">{activeUniqueUrlIdentifier}</Item>
        <Item label="Preview URL">
          {previewUrl ? (
            <span>
              <a href={previewUrl} target="_blank" rel="noopener noreferrer">
                {previewUrl}
              </a>
              <Tooltip title={isPreviewLinkCopied ? "Copied!" : "Copy"}>
                <Button
                  icon={<CopyOutlined />}
                  size="small"
                  style={{ marginLeft: 8 }}
                  onClick={handleCopyUrl}
                />
              </Tooltip>
            </span>
          ) : (
            "-"
          )}
        </Item>
      </Descriptions>
    </Card>
  );
};

export default BlogTreeNodeDetails;
